import { gql } from "@apollo/client";

export const GET_LOCATION_ORDER_LIST = gql`
    query GetLocationOrderList($request: WarehouseLocationOrderListRequestInput!) {
        getLocationOrderList(request: $request) {
            id
            locationId
            orderId
            trackingNumber
            status
            locationOrderNo
            putawayAt
            updatedAt
            nextAction
            exceptionReasonCode
            putawayDays
        }
    }
`;

export interface WarehouseLocationOrderListRequestInput {
    warehouseId: number;
    locationNo: string;
}

export interface WarehouseLocationOrderType {
    id: number;
    locationId: number;
    orderId: number;
    trackingNumber: string;
    status: number;
    locationOrderNo: number;
    putawayAt: number | null;
    updatedAt: number | null;
    nextAction: string | null;
    exceptionReasonCode: string | null;
    putawayDays: number | null;
}

export interface GetLocationOrderListResponse {
    getLocationOrderList: WarehouseLocationOrderType[];
}

